export const DEFAULT_ORDER = 'Default'
export const ASCENDANT_ORDER = 'Ascendant'
export const DECREASING_ORDER = 'Decreasing'

export const DEFAULT_FORMAT = 'Default'
export const STRING_FORMAT = 'String'
export const NUMBER_FORMAT = 'Number'
export const NUMBER_THOUSAND_SEPARATOR_FORMAT = 'Number, thousand separator'
export const DATE_FORMAT = 'Date'
export const BOOLEAN_FORMAT = 'Boolean'
export const MAP_FORMAT = 'Map'
export const DOCUMENT_FORMAT = 'Document'
export const THUMBNAIL_IMAGE_FORMAT = 'Thumbnail image'
export const DATETIME_FORMAT = 'Datetime'
export const MULTISELECT_FORMAT = 'Multiselect'

export const NONE_AGGREGATION = 'None'
export const CONCAT_VALUES_AGGREGATION = 'Concat values'
export const HIDDEN_GROUPING_AGGREGATION = 'Hidden grouping'
export const COUNT_AGGREGATION = 'Count'
export const SUMMATION_AGGREGATION = 'Summation'
export const AVERAGE_AGGREGATION = 'Average'
export const MINIMUM_AGGREGATION = 'Minimum'
export const MAXIMUM_AGGREGATION = 'Maximum'
export const GROUPING_AGGREGATION = 'Grouping'

export const SELECT_JOIN = 'Select Join'
export const LEFT_JOIN = 'LEFT JOIN'
export const RIGHT_JOIN = 'RIGHT JOIN'
export const INNER_JOIN = 'INNER JOIN'
export const FULL_OUTER_JOIN = 'FULL OUTER JOIN'
export const SUB_QUERY = 'SUB QUERY'

export const DEFAULT_GROUP_CONCAT_SEPARATOR = ';'

export const ORDER_LABELS = [
  { id: -1, value: DEFAULT_ORDER },
  { id: 0, value: ASCENDANT_ORDER },
  { id: 1, value: DECREASING_ORDER },
]

export const FORMAT_LABELS = [
  { id: -1, value: DEFAULT_FORMAT },
  { id: 0, value: STRING_FORMAT },
  { id: 1, value: NUMBER_FORMAT },
  { id: 2, value: NUMBER_THOUSAND_SEPARATOR_FORMAT },
  { id: 3, value: DATE_FORMAT },
  { id: 4, value: BOOLEAN_FORMAT },
  { id: 5, value: MAP_FORMAT },
  { id: 6, value: DOCUMENT_FORMAT },
  { id: 7, value: THUMBNAIL_IMAGE_FORMAT },
  { id: 8, value: DATETIME_FORMAT },
  // { id: 9, value: CHECKBOXLIST_FORMAT },
  { id: 10, value: MULTISELECT_FORMAT },
]

export const AGGREGATION_LABELS = [
  { id: -1, value: NONE_AGGREGATION },
  { id: 0, value: CONCAT_VALUES_AGGREGATION },
  { id: 1, value: HIDDEN_GROUPING_AGGREGATION },
  { id: 2, value: COUNT_AGGREGATION },
  { id: 3, value: SUMMATION_AGGREGATION },
  { id: 4, value: AVERAGE_AGGREGATION },
  { id: 5, value: MINIMUM_AGGREGATION },
  { id: 6, value: MAXIMUM_AGGREGATION },
  { id: 7, value: GROUPING_AGGREGATION },
]

export const JOIN_LABELS = [
  { id: -1, value: SELECT_JOIN },
  { id: 0, value: LEFT_JOIN },
  { id: 1, value: RIGHT_JOIN },
  { id: 2, value: INNER_JOIN },
  { id: 3, value: FULL_OUTER_JOIN },
  { id: 4, value: SUB_QUERY },
]
